import { Component, OnInit, ViewChild, ErrorHandler } from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
@Component({
  selector: 'app-doctorgrid',
  templateUrl: './doctorgrid.component.html',
  styleUrls: ['./doctorgrid.component.css']
})
export class DoctorgridComponent implements OnInit {

  title = "Doctor Details";
  dtOptions: any = {};
  DoctorList: any[] = [];
  mode: any;
  DOC_NOs: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  isSearch: boolean;
  data: any;
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;


  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  ngOnInit(): void {
    this.GetAllDoctorDetails();
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.dtOptions = {

      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          className: 'btn btn-radius',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
      ],
    }
  }

  // ngAfterViewInit(): void {
  //   this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //     dtInstance.columns().every(function () {
  //       const that = this;
  //       $('input', this.footer()).on('keyup change', function () {
  //         if (that.search() !== this['value']) {
  //           that
  //             .search(this['value'])
  //             .draw();
  //         }
  //       });
  //     });
  //   });
  // }

  GetAllDoctorDetails() {
    debugger;
    this.isSearch = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDoctorDetails();
    this.data.subscribe((Response: any) => {
      this.DoctorList = Response.Result;
      this.rerender();
       document.getElementById('loader-spinner').style.display = "none";
    }, (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      if (error.status == 401 || error.status == 500) {
        this.errorHandler.handleError(error);
      }
      else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');


      }
    });
  }

  // deletes() {
  //   Swal.fire({
  //     position: 'top-end',
  //     title: 'Do You Want To Delete',
  //     text: 'If Deleted, Data can not be reverted back!',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes',
  //     cancelButtonText: 'No'
  //   }).then((result) => {
  //     if (result.value) {
  //       Swal.fire(
  //         'Data Record Deleted Successfully..'
  //       )
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire(
  //         'Changes will be Discarded..'
  //       )
  //     }
  //   })
  // }

  DeleteDoctorDetails(DO_Id: number) {
    debugger
    Swal.fire({
      position: 'top-end',
      title: 'Do You Want To Delete',
      text: 'If Deleted, Data can not be reverted back!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.userService.DeleteDoctorDetails(DO_Id).subscribe(
          (data: any) => {
            Swal.fire('Data Record Deleted Successfully..')
          }, (error) => {
            Swal.fire('Changes will be Discarded..')
          });
      }
    })
  }

    /*for Datatable*/
    ngAfterViewInit(): void {
      this.dtTrigger.next();
    }


    ngOnDestroy(): void {
      this.dtTrigger.unsubscribe();
    }

    rerender(): void {
      try {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
       this.dtTrigger.next();
      } catch (err) {
        console.log(err);
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/doctor/doctorgrid/doctorgrid.component.ts